import { Injectable } from "@angular/core";

import { FieldMetadata } from "src/cer/cer-data/cer-data-types";
import { UiCommand } from "@ui/cer-ui-types";
import { CerPromptService, PromptInput } from "@ui/cer-ui-prompt.service";
import { ICerViewComponent } from "@form/cer-form-view";

import { AfregningstabelDto, ProductClient, ProductSyncCommand } from "../api";
import { lastValueFrom, Observable, take } from "rxjs";
import { CerUiIcons } from "@ui/cer-ui-icons";

export const uiCmdSyncSelected: UiCommand = { text: 'Synkroniser markeret', tooltipText: 'Synkroniser markerede udgivelser fra oprindelig kontrakt database', id: 'syncSelected', target: ".e-content", needSelection: true, iconCss: CerUiIcons.research };

@Injectable({ providedIn: 'root' })
export class ProductService {

    public uiCmdSyncNum: UiCommand =
        { text: '', tooltipText: 'Synkroniser valgfri udgivelse fra oprindelig kontrakt database', id: 'syncNum', iconCss: CerUiIcons.research, align: 'right' };
    public uiCmdBudgetCreateStandard: UiCommand =
        { text: 'Std.', tooltipText: 'Opret alle standard budgetværdier', id: 'budgetCreateStandard', iconCss: 'e-menu-icon e-icons-org e-add-below', align: 'center' };
    public uiCmdBudgetApprove: UiCommand =
        { text: 'Godkend', tooltipText: 'Godkend budgetværdier', id: 'budgetApprove', iconCss: 'e-menu-icon e-icons-org e-redo', align: 'center' };

    constructor(private client: ProductClient, private ui: CerPromptService) {
    }

    public budgetUpdateFromProductList(c: ICerViewComponent, productDtos: any[], create: boolean, approve: boolean) {
        if (productDtos?.length > 0) {
            var productLegacyIds: number[] = [];
            productDtos.forEach(product => {
                var legacyId: number = product?.legacyId;
                if (legacyId) {
                    productLegacyIds.push(legacyId);
                }
            });
            if (productLegacyIds.length > 0) {
                this.sync(c, false, create, approve, productLegacyIds, null, null);
            }
            else {
                this.ui.toast('Budget vedligehold', 'Budget vedligehold ikke muligt. Ingen Id tilgængelig.');
            }
        }
        else {
            this.ui.toast('Budget vedligehold', 'Ingen udgivelse er markeret');
        }

    }

    public syncFromProductAllList(c: ICerViewComponent, productAllDtos: any[]) {
        if (productAllDtos?.length > 0) {
            var legacyIds: number[] = [];
            productAllDtos.forEach(dto => {
                var legacyId: number = dto.id;
                if (legacyId != null) {
                    legacyIds.push(legacyId);
                }
            });
            if (legacyIds.length > 0) {
                this.sync(c, true, false, false, legacyIds, null, null);
            }
        }
    }

    public syncFromProductList(c: ICerViewComponent, productDtos: any[]) {
        if (productDtos?.length > 0) {
            var legacyIds: number[] = [];
            productDtos.forEach(dto => {
                var legacyId: number = dto.legacyId;
                if (legacyId != null) {
                    legacyIds.push(legacyId);
                }
            });
            if (legacyIds.length > 0) {
                this.sync(c, true, false, false, legacyIds, null, null);
            }
            else {
                var num = productDtos[0]?.num;
                if (num?.length > 0) {
                    this.sync(c, true, false, false, null, num, null);
                }
            }
        }
        else {
            this.ui.toast('Synkroniser', 'Ingen udvigelse er markeret');
        }
    }

    public syncNumFromPrompt(c: ICerViewComponent, numMeta: FieldMetadata, projectNumMeta: FieldMetadata) {
        var inputs: PromptInput[] = [
            { label: numMeta.text, id: numMeta.name, placeholder: 'Angiv ISBN', value: '', element: null },
            { label: projectNumMeta.text, id: projectNumMeta.name, placeholder: '.. eller angiv Projektnr.', value: '', element: null }
        ];
        this.ui.promptInputs('Angiv udgivelse der skal synkroniseres fra oprindelig database', this.uiCmdSyncNum.tooltipText, inputs).then(
            result => {
                if (result.action == 'ok') {
                    var productNumValue: string = result.inputs.find(i => i.id == numMeta.name).value;
                    var projectNumValue: string = result.inputs.find(i => i.id == projectNumMeta.name).value;
                    if (productNumValue?.length > 0 || projectNumValue?.length > 0) {
                        this.sync(c, true, false, false, null, productNumValue, projectNumValue);
                    }
                }
            }
        );
    }

    public sync(c: ICerViewComponent, sync: boolean, budgetCreate: boolean, budgetApprove: boolean, legacyIds: number[], productNum: string, projectNum: string) {
        var cmd: ProductSyncCommand = new ProductSyncCommand();
        var title: string = null;
        if (legacyIds?.length > 0) {
            if (legacyIds.length == 1) {
                title = ' udgivelse';
            }
            else {
                title = legacyIds.length + ' udgivelser';
            }
            cmd.legacyIds = legacyIds;
        }
        else if (productNum?.length > 0) {
            title = Array.isArray(productNum) ? productNum.length + ' udgivelser' : (productNum ? productNum : projectNum);
            cmd.productNums = [productNum];
        }
        else if (projectNum?.length > 0) {
            title = Array.isArray(productNum) ? productNum.length + ' udgivelser' : (productNum ? productNum : projectNum);
            cmd.projectNums = [projectNum];
        }
        if (title?.length > 0) {
            if (budgetCreate) {
                title = 'Opretter budget for ' + title;
                cmd.budgetCreate = true;
                cmd.budgetApprove = budgetApprove;
            }
            else if (budgetApprove) {
                title = 'Godkender budget for ' + title;
                cmd.budgetApprove = true;
            }
            if (sync) {
                title = 'Synkroniserer ' + title;
                cmd.legacySync = true;
            }
            if (cmd.legacySync || cmd.budgetCreate || cmd.budgetApprove) {
                this.syncCommand(c, title, cmd);
            }
        }
    }

    public syncCommand(c: ICerViewComponent, title: string, cmd: ProductSyncCommand) {
        this.ui.operationBegin(title);
      this.client.sync(cmd).subscribe({
            next: (result) => {
                this.ui.operationEnd();
                var res: string = result?.toString() ?? '0';
                if (cmd.budgetCreate) {
                    res += ' budgetpost' + (result == 1 ? '' : 'er') + ' oprettet';
                }
                else if (cmd.budgetApprove) {
                    res += ' budgetpost' + (result == 1 ? '' : 'er') + ' godkendt';
                }
                else {
                    res += ' udgivelse' + (result == 1 ? '' : 'r') + ' synkroniseret';
                }
                this.ui.toast(res);
                c.research();
            },
            error: (error: any)=> {
                this.ui.operationEndError(error);
                c.research();
            }
        });
    }

    public async productRightsQuery(product: any): Promise<AfregningstabelDto[]> {
        return lastValueFrom<AfregningstabelDto[]>(this.client.productRights(product.num).pipe(take(1)));
    }

    public profitLossActivateInput(txts: string[]): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.ui.confirm(txts, 'Marker "Driftsføres"', { defaultAction: 'cancel'})
                .then(action => {
                    if (action == 'ok') {
                        resolve(true);
                    }
                    else {
                        resolve(false);
                    }
                })
                .catch(error => reject(error));
        });
    }

    public profitLossActivate(profitLossSuggestValue: boolean, productNums: string[]): Observable<number> {
        return this.client.financeProjectSetProfitLoss(profitLossSuggestValue, productNums);
    }
}
